import React, { Component, Fragment } from "react";
import { bool, node, string, shape, oneOf, arrayOf, func } from "prop-types";
import { connect } from "react-redux";
import PageTransition from "react-router-page-transition";
import { Route, withRouter, Link } from "react-router-dom";

import { getTransition } from "util/transition";
import Notification from "pages/_components/Notification";
import Image from "pages/_components/Image";

import { resizableRoute } from "pages/_components/Resizable";
import ErrorBoundary from "pages/_components/ErrorBoundary";
import I18n from "pages/_components/I18n";
import NavigationBarDesktop from "pages/_components/NavigationBarDesktop";
import FooterDesktop from "pages/_components/FooterDesktop";
import Menu from "pages/_components/menu/Menu";
import Navbar from "react-bootstrap/lib/Navbar";
import ToggleSidebar from "pages/_components/menu/ToggleSidebar";
import classNames from "classnames";
import WithPermissionsRedirect from "../_components/WithPermissionsRedirect";

// const SCREEN_WIDTH_REFERENCE = 1024;
class DefaultLayout extends Component {
    state = {
        transition: "",
        isSidebarCollapsed: false,
        isSidebarHovered: false,
        styles: {},
        // widthScreen: window.innerWidth,
    };

    // componentDidMount() {
    //     const { isMobileNative } = this.props;

    //     if (isMobileNative) {
    //         const deviceHeight = window.innerHeight;

    //         this.setState({
    //             styles: {
    //                 position: "absolute",
    //                 top: 0,
    //                 height: deviceHeight,
    //             },
    //         });
    //     }
    //     window.addEventListener("resize", this.updateDimensions);
    //     this.validateShowMenu();
    // }

    // componentDidUpdate(prevProps, prevState) {
    //     if (prevState.widthScreen !== this.state.widthScreen) {
    //         this.validateShowMenu();
    //     }
    // }

    // validateShowMenu = () => {
    //     if (this.state.widthScreen >= SCREEN_WIDTH_REFERENCE) {
    //         this.setState({ isSidebarCollapsed: false });
    //     } else {
    //         this.setState({ isSidebarCollapsed: TextTrackCueList });
    //     }
    // };

    // updateDimensions = () => {
    //     this.setState({ widthScreen: window.innerWidth });
    // };

    handleToggleSidebar = () => {
        const { isSidebarCollapsed } = this.state;

        this.setState((prevState) => ({ isSidebarCollapsed: !prevState.isSidebarCollapsed }));

        if (!isSidebarCollapsed) {
            window.dispatchEvent(new Event("resize"));
        }
    };

    /* eslint-disable-next-line react/sort-comp, camelcase */
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { location } = this.props;

        if (location.pathname !== nextProps.location.pathname) {
            this.setState({
                transition:
                    (nextProps.location.state && nextProps.location.state.transition) ||
                    nextProps.transition ||
                    getTransition(this.props, nextProps),
            });
        }
    }

    setSidebarHover = (isMouseHover) => {
        this.setState({ isSidebarHovered: isMouseHover });
    };

    getMobileLayout = (matchProps) => {
        const { component: ReceivedComponent, isMobile, isDesktop, path } = this.props;
        const extras = { isMobile, isDesktop };
        const { transition, styles } = this.state;
        const isDashboard = path === "/desktop";

        return (
            <div
                style={styles}
                className={classNames(transition, {
                    dashboard: isDashboard,
                })}>
                <PageTransition timeout={600}>
                    <div className="view-wrapper theme-auth transition-item">
                        <ErrorBoundary>
                            <Notification scopeToShow="menu" />
                            <ReceivedComponent {...matchProps} {...extras} />
                        </ErrorBoundary>
                    </div>
                </PageTransition>
            </div>
        );
    };

    getDesktopLayout = (matchProps) => {
        const {
            component: ReceivedComponent,
            isMobile,
            isDesktop,
            isMobileNative,
            componentProps,
            withoutLayout,
            path,
            showMenu,
        } = this.props;
        const extras = { isMobile, isDesktop, isMobileNative, ...componentProps };
        const { isSidebarCollapsed, isSidebarHovered } = this.state;
        const buildNumber = window.BUILD_NUMBER ? `(Build ${window.BUILD_NUMBER})` : "";
        const isDashboard = path === "/desktop";

        return (
            <ErrorBoundary>
                {!withoutLayout && (
                    <div
                        className={classNames("app-default-container", {
                            "sidebar-collapsed": isSidebarCollapsed,
                            dashboard: isDashboard,
                        })}>
                        {showMenu && (
                            <header className={classNames("app-default-header")}>
                                <NavigationBarDesktop
                                    onToggleSidebar={this.handleToggleSidebar}
                                    isCollapsed={isSidebarCollapsed}
                                />
                            </header>
                        )}
                        {!showMenu && (
                            <header className={classNames("app-default-header")}>
                                <div style={{ paddingTop: "10px", paddingLeft: "15px" }}>
                                    <Image src="images/logoCompanyWhite.svg" />
                                </div>
                            </header>
                        )}
                        {/* <div className="menu-height" /> */}
                        {showMenu && (
                            <aside className="app-default-sidebar">
                                <div>
                                    <div className="d-flex">
                                        <ToggleSidebar
                                            isSidebarCollapsed={isSidebarCollapsed}
                                            onToggle={this.handleToggleSidebar}
                                        />
                                        <Navbar.Brand>
                                            <Link className="navbar-brand" to="/desktop">
                                                <Image src="images/logoCompany.svg" />
                                                <I18n
                                                    id="global.companyName"
                                                    componentProps={{ className: "visually-hidden" }}
                                                />
                                            </Link>
                                        </Navbar.Brand>
                                    </div>
                                    <Menu
                                        isMobile={isMobile}
                                        onToggleSidebar={this.handleToggleSidebar}
                                        isCollapsed={isSidebarCollapsed}
                                        isSidebarHovered={isSidebarHovered}
                                    />
                                </div>

                                <p className="text-muted app-version">
                                    {/* TODO remove this side effect */}
                                    {/* global process */}
                                    <I18n id="global.version" component="small" /> {process.env.REACT_APP_VERSION}{" "}
                                    {buildNumber}
                                </p>
                            </aside>
                        )}
                        <main className="app-default-content" role="main">
                            <div className="view-wrapper theme-auth">
                                <Notification scopeToShow="menu" />
                                <ReceivedComponent {...matchProps} {...extras} />
                            </div>
                        </main>

                        <FooterDesktop justifyEnd />
                    </div>
                )}
                {withoutLayout && (
                    <div
                        className={classNames("app-page sidebar-collapsed", {
                            dashboard: isDashboard,
                        })}>
                        <div className="app-content">
                            <div className="view-wrapper theme-auth">
                                <ReceivedComponent {...matchProps} {...extras} />
                            </div>
                        </div>
                    </div>
                )}
            </ErrorBoundary>
        );
    };

    render() {
        const { component: ReceivedComponent, somePermissions, permissions, comparator, ...rest } = this.props;

        return (
            <WithPermissionsRedirect
                somePermissions={somePermissions}
                permissions={permissions}
                comparator={comparator}>
                <Route
                    {...rest}
                    render={(matchProps) => {
                        const { isMobile } = this.props;

                        if (isMobile) {
                            return <Fragment>{this.getMobileLayout(matchProps)}</Fragment>;
                        }

                        return <Fragment>{this.getDesktopLayout(matchProps)}</Fragment>;
                    }}
                />
            </WithPermissionsRedirect>
        );
    }
}

DefaultLayout.propTypes = {
    showMenu: bool,
    isDesktop: bool,
    isMobile: bool,
    isMobileNative: bool,
    component: node.isRequired,
    componentProps: shape({}).isRequired,
    transition: oneOf([
        "transition-drill-out",
        "transition-drill-in",
        "transition-flow-close",
        "transition-flow-open",
        "transition-change-feature",
    ]),
    location: shape({
        pathname: string.isRequired,
        state: shape({
            transition: oneOf([
                "transition-drill-out",
                "transition-drill-in",
                "transition-flow-close",
                "transition-flow-open",
                "transition-change-feature",
            ]),
        }),
    }).isRequired,
    withoutLayout: bool,
    somePermissions: bool,
    permissions: arrayOf(string),
    comparator: func,
    path: string.isRequired,
    activeEnvironment: shape({ type: string }).isRequired,
    firstName: string.isRequired,
};

DefaultLayout.defaultProps = {
    showMenu: true,
    isDesktop: false,
    isMobile: false,
    isMobileNative: false,
    transition: "",
    withoutLayout: false,
    somePermissions: false,
    permissions: null,
    comparator: null,
};

export default withRouter(connect()(resizableRoute(DefaultLayout)));
